import type React from "react";

export type BlockWithIdAndComponent = {
  id: number | string;
  __component: string;
  sectionId?: string;
  isVisible?: boolean;
  [key: string]: unknown;
};

export interface DynamicZoneRendererProps {
  blocksData?: BlockWithIdAndComponent[];
  blocksSchema: Record<string, React.ComponentType<any>>;
}

export const DynamicZoneRenderer = ({
  blocksData,
  blocksSchema,
}: DynamicZoneRendererProps) => {
  return (
    <>
      {blocksData?.map((block, idx) => {
        if (!block || block?.__component == null) return null;
        const Component = blocksSchema[block.__component];
        if (!Component) return null;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const visible = (block as any).isVisible !== false;
        if (!visible) return null;

        return (
          <Component
            key={`section_${block.id}-${idx + 1}`}
            sectionId={block.__component.split(".").pop()}
            {...block}
          />
        );
      })}
    </>
  );
};
